
    export enum EnumChometzSaleOption {
			OUSale = 0,
			NonOUSale = 1,
    }